import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import dayjs from "dayjs";
import { Action } from "../../../constants/Common";
import { withTranslation } from "react-i18next";


const IndividualMilestone = (props) => {
  return (
    <div className="editDeliverable_height h-auto my-4">
      {props?.action === Action.UPDATE && (
        <h6 className="mb-0">
          {props.t(props.eachMilestoneIndex + 1)}. {props.t("Current Milestone")}
        </h6>
      )}
      <div className="dashed_border position-relative p-2">
        <div className="row">
          <div className="col-md-12 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Name")}
              name="name"
              readOnly={true}
              required
              value={
                props?.action === Action.CREATE
                  ? props?.eachMilestone?.name ?? ""
                  : typeof props?.eachMilestone?.name === "object"
                  ? props?.eachMilestone?.name?.old
                  : props?.eachMilestone?.name
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Description")}
              name="description"
              type="text"
              readOnly={true}
              multiline
              value={
                props?.action === Action.CREATE
                  ? props?.eachMilestone?.description ?? ""
                  : typeof props?.eachMilestone?.description === "object"
                  ? props?.eachMilestone?.description?.old
                  : props?.eachMilestone?.description
              }
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Assigned Deliverable")}
              name="deliverable"
              type="text"
              readOnly={true}
              value={props?.eachMilestone?.deliverable?.name}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Weight")}
              name="weight"
              required
              readOnly={true}
              value={
                props?.action === Action.CREATE
                  ? props?.eachMilestone?.weight ?? ""
                  : typeof props?.eachMilestone?.weight === "object"
                  ? props?.eachMilestone?.weight?.old
                  : props?.eachMilestone?.weight
              }
            />
          </div>
          {/* <div className="col-md-6 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Goal")}
              name="aim"
              required
              readOnly={true}
              value={
                props?.action === Action.CREATE
                  ? props?.eachMilestone?.aim ?? ""
                  : typeof props?.eachMilestone?.aim === "object"
                  ? props?.eachMilestone?.aim?.old
                  : props?.eachMilestone?.aim
              }
            />
          </div> */}
        </div>
        <div className="row">
          <div className="col-md-12 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Output")}
              name="output"
              type="text"
              readOnly={true}
              multiline
              value={
                props?.action === Action.CREATE
                  ? props?.eachMilestone?.output ?? ""
                  : typeof props?.eachMilestone?.output === "object"
                  ? props?.eachMilestone?.output?.old
                  : props?.eachMilestone?.output
              }
              required
            />
          </div>
        </div>
        <div className="row">
          <div className=" col-md-6 changeRequest_datePicker mt-2 pe-0">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Start Date")}
              name="estimatedStartDate"
              required
              readOnly={true}
              value={
                props?.action === Action.CREATE
                  ? (props?.eachMilestone?.estimatedStartDate
                      ? dayjs(props?.eachMilestone?.estimatedStartDate)
                      : ""
                    ).format("DD-MM-YYYY")
                  : typeof props?.eachMilestone?.estimatedStartDate ===
                      "object" && props?.eachMilestone?.estimatedStartDate?.old
                  ? dayjs(props?.eachMilestone?.estimatedStartDate?.old).format(
                      "DD-MM-YYYY"
                    )
                  : props?.eachMilestone?.estimatedStartDate
                  ? dayjs(props?.eachMilestone?.estimatedStartDate).format(
                      "DD-MM-YYYY"
                    )
                  : ""
              }
            />
          </div>
          <div className="col-md-6 changeRequest_datePicker mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("End Date")}
              name="estimatedEndDate"
              required
              readOnly={true}
              value={
                props?.action === Action.CREATE
                  ? props?.eachMilestone?.estimatedEndDate
                    ? dayjs(props?.eachMilestone?.estimatedEndDate).format(
                        "DD-MM-YYYY"
                      )
                    : ""
                  : typeof props?.eachMilestone?.estimatedEndDate ===
                      "object" && props?.eachMilestone?.estimatedEndDate?.old
                  ? dayjs(props?.eachMilestone?.estimatedEndDate?.old).format(
                      "DD-MM-YYYY"
                    )
                  : props?.eachMilestone?.estimatedEndDate
                  ? dayjs(props?.eachMilestone?.estimatedEndDate).format(
                      "DD-MM-YYYY"
                    )
                  : ""
              }
            />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-12">
            <p className="title">{props.t('Cost')}: &nbsp; SAR { 
              props?.action === Action.CREATE
                ? props?.eachMilestone?.cost.toFixed(2) ?? ""
                : typeof props?.eachMilestone?.cost === "object"
                ? props?.eachMilestone?.cost?.old.toFixed(2)
                : props?.eachMilestone?.cost.toFixed(2)}
            </p>
          </div>
        </div>
        {props?.action === Action.CREATE && props?.eachMilestone?.items.length > 0 &&
          props?.eachMilestone.items.map((_row, index) => ( 
                <>
                <div className="row" key={index}>
                   
                    <div className=" col-md-6 mt-2 pe-0">
                        {/* <TextField
                            sx={{ marginLeft: 3 }}
                            variant="outlined"
                            size="small"
                            label={props.t("Planned Cost")}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">SAR</InputAdornment>,
                            }}
                            fullWidth
                            value={_row.plannedCost}
                            inputProps={{
                                readOnly: true
                            }}
                            className="m-0"
                        /> */}
                         <TextField
                                sx={{ marginLeft: 3 }}
                                minimumValue="0"
                                id="milestone-cost"
                                variant="outlined"
                                // label='Deliverable Cost'
                                decimalPlaces={2}
                                inputProps={{
                                    readOnly: true
                                }}
                                className="m-0"
                                value={_row.plannedCost}
                                // size="small"
                                currencySymbol={props.t("SAR")}
                                fullWidth
                                placeholder={props.t("Planned Cost")}
                            />
                    </div>
                    <div className=" col-md-6 mt-2 pe-0">
                        <TextField
                            label={`${_row.type !== 'Others' ? props.t('Budget Type') : props.t('Custom Budget Type')} `}
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={_row.budgetType}
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </div>
                </div>
                </>
              )
        )}

        {props?.action === Action.UPDATE && props?.eachMilestone?.items?.old.length > 0 &&
          props?.eachMilestone.items.old.map((_row, index) => ( 
                <>
                <div className="row" key={index}>
                    <div className=" col-md-6 mt-2 pe-0">
                        {/* <TextField
                            sx={{ marginLeft: 3 }}
                            variant="outlined"
                            size="small"
                            label={props.t("Planned Cost")}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">SAR</InputAdornment>,
                            }}
                            fullWidth
                            value={_row.plannedCost}
                            inputProps={{
                                readOnly: true
                            }}
                            className="m-0"
                        /> */}
                        <TextField
                                sx={{ marginLeft: 3 }}
                                minimumValue="0"
                                id="milestone-cost"
                                // label='Deliverable Cost'
                                decimalPlaces={2}
                                inputProps={{
                                    readOnly: true
                                }}
                                className="m-0"
                                value={_row.plannedCost}
                                variant="outlined"
                                // size="small"
                                currencySymbol={props.t("SAR")}
                                fullWidth
                                placeholder={props.t("Planned Cost")}
                            />
                    </div>
                    <div className=" col-md-6 mt-2 pe-0">
                        <TextField
                            label={`${_row.type !== 'Others' ? props.t('Budget Type') : props.t('Custom Budget Type')} `}
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={_row.budgetType}
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </div>
                </div>
                </>
              )
        )}
      </div>

      {props?.action === Action.UPDATE && (
        <div className="my-4">
          <h6 className="mb-0">{props.t("Requested Milestone")}</h6>
          <div className="dashed_border position-relative p-2">
            <div className="row">
              <div className="col-md-12 mt-2">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("Name")}
                  name="name"
                  readOnly={true}
                  variant={`${typeof props?.eachMilestone?.name === "object" ? "filled" : 'outlined'}`}
                  required
                  value={
                    typeof props?.eachMilestone?.name === "object"
                      ? props?.eachMilestone?.name?.new
                      : props?.eachMilestone?.name
                  }
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mt-2">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("Description")}
                  name="description"
                  type="text"
                  readOnly={true}
                  variant={`${typeof props?.eachMilestone?.description === "object" ? "filled" : 'outlined'}`}
                  multiline
                  value={
                    typeof props?.eachMilestone?.description === "object"
                      ? props?.eachMilestone?.description?.new
                      : props?.eachMilestone?.description
                  }
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mt-2">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("Assigned Deliverable")}
                  name="deliverable"
                  type="text"
                  readOnly={true}
                  value={props?.eachMilestone?.deliverable?.name}
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mt-2">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("Weight")}
                  name="weight"
                  required
                  readOnly={true}
                  variant={`${typeof props?.eachMilestone?.weight === "object" ? "filled" : 'outlined'}`}
                  value={
                    typeof props?.eachMilestone?.weight === "object"
                      ? props?.eachMilestone?.weight?.new
                      : props?.eachMilestone?.weight
                  }
                />
              </div>
              {/* <div className="col-md-6 mt-2">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("Goal")}
                  name="aim"
                  required
                  readOnly={true}
                  variant={`${typeof props?.eachMilestone?.aim === "object" ? "filled" : 'outlined'}`}
                  value={
                    typeof props?.eachMilestone?.aim === "object"
                      ? props?.eachMilestone?.aim?.new
                      : props?.eachMilestone?.aim
                  }
                />
              </div> */}
            </div>
            <div className="row">
              <div className="col-md-12 mt-2">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("Output")}
                  name="output"
                  type="text"
                  readOnly={true}
                  variant={`${typeof props?.eachMilestone?.output === "object" ? "filled" : 'outlined'}`}
                  multiline
                  value={
                    typeof props?.eachMilestone?.output === "object"
                      ? props?.eachMilestone?.output?.new
                      : props?.eachMilestone?.output
                  }
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className=" col-md-6 changeRequest_datePicker mt-2 pe-0">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("Start Date")}
                  name="estimatedStartDate"
                  required
                  readOnly={true}
                  variant={`${typeof props?.eachMilestone?.estimatedStartDate === "object" ? "filled" : 'outlined'}`}
                  value={
                    typeof props?.eachMilestone?.estimatedStartDate ===
                      "object" && props?.eachMilestone?.estimatedStartDate?.new
                      ? dayjs(
                          props?.eachMilestone?.estimatedStartDate?.new
                        ).format("DD-MM-YYYY")
                      : props?.eachMilestone?.estimatedStartDate
                      ? dayjs(props?.eachMilestone?.estimatedStartDate).format(
                          "DD-MM-YYYY"
                        )
                      : ""
                  }
                />
              </div>
              <div className="col-md-6 changeRequest_datePicker mt-2">
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label={props.t("End Date")}
                  name="estimatedEndDate"
                  required
                  readOnly={true}
                  variant={`${typeof props?.eachMilestone?.estimatedEndDate === "object" ? "filled" : 'outlined'}`}
                  value={
                    typeof props?.eachMilestone?.estimatedEndDate ===
                      "object" && props?.eachMilestone?.estimatedEndDate?.new
                      ? dayjs(
                          props?.eachMilestone?.estimatedEndDate?.new
                        ).format("DD-MM-YYYY")
                      : props?.eachMilestone?.estimatedEndDate
                      ? dayjs(props?.eachMilestone?.estimatedEndDate).format(
                          "DD-MM-YYYY"
                        )
                      : ""
                  }
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-12">
                <p className="title">{props.t('Cost')}: &nbsp; SAR { 
                  typeof props?.eachMilestone?.cost === "object"
                    ? (parseFloat(props?.eachMilestone?.cost?.new).toFixed(2) ?? '0.00')
                    : (props?.eachMilestone?.cost.toFixed(2) ?? '0.00')}
                </p>
              </div>
            </div>
            {props?.eachMilestone?.items?.new?.length > 0 &&
              props?.eachMilestone?.items?.new.map((_row, index) => ( 
                <>
                <div className="row" key={index}>
                    
                    <div className=" col-md-6 mt-2 pe-0">
                        {/* <TextField
                            sx={{ marginLeft: 3 }}
                            variant={`${
                              props?.action === Action.CREATE
                                ? "outlined"
                                : (!_row?.id || props?.eachMilestone?.items?.old.find((item) => item?.id === _row?.id && _row?.plannedCost !== item?.plannedCost) ) ? "filled" : "outlined"
                            }`}
                            size="small"
                            label={props.t("Planned Cost")}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">SAR</InputAdornment>,
                            }}
                            fullWidth
                            value={_row.plannedCost}
                            inputProps={{
                                readOnly: true
                            }}
                            className="m-0"
                        /> */}
                        <TextField
                                sx={{ marginLeft: 3 }}
                                minimumValue="0"
                                id="milestone-cost"
                                variant={`${
                                  props?.action === Action.CREATE
                                    ? "outlined"
                                    : (!_row?.id || props?.eachMilestone?.items?.old.find((item) => item?.id === _row?.id && _row?.plannedCost !== item?.plannedCost) ) ? "filled" : "outlined"
                                }`}
                                // label='Deliverable Cost'
                                decimalPlaces={2}
                                inputProps={{
                                    readOnly: true
                                }}
                                className="m-0"
                                value={_row.plannedCost}
                                // size="small"
                                currencySymbol={props.t("SAR")}
                                fullWidth
                                placeholder={props.t("Planned Cost")}
                            />
                    </div>
                    <div className=" col-md-6 mt-2 pe-0">
                        <TextField
                            label={`${_row.type !== 'Others' ? props.t('Budget Type') : props.t('Custom Budget Type')} `}
                            variant={`${
                              props?.action === Action.CREATE
                                ? "outlined"
                                : (!_row?.id || props?.eachMilestone?.items?.old.find((item) => item?.id === _row?.id && _row?.budgetType !== item?.budgetType) ) ? "filled" : "outlined"
                            }`}
                            size="small"
                            fullWidth
                            value={_row.budgetType}
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </div>
                </div>
                </>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default withTranslation() (IndividualMilestone);
